import NoLoyaltyCard from './NoLoyaltyCard';
import { connect } from 'react-redux';

// Redux
const mapStateToProps = (state) => {
  return {
    cardNumber: state.loyalty.cardNumber,
  };
}

const ConnectedVersion = connect(
  mapStateToProps
)(NoLoyaltyCard);

export default ConnectedVersion;



// WEBPACK FOOTER //
// ./src/pages/NoLoyaltyCard/index.js